// Helpers

window.helpers = {
    setup: function() {
        
    },
    el: function(el) {
        return document.querySelector(el);
    },
    hasClass: function(el, className) {
        if ( el.classList.contains(className) ) {
            return true;
        }
    },
    removeClass: function(el, className) {
        el.classList.remove(className);
    },
    addClass: function(el, className) {
        el.classList.add(className);
    },
    toggleClass: function(el, className) {
        el.classList.toggle(className);
    },
    parent: function(el) {
        return el.parentNode;
    },
    parents: function(el, selector) {
        const parents = [];
        while ((el = el.parentNode) && el !== document) {
            if (!selector || el.matches(selector)) parents.unshift(el);
        }
        return parents;
    },
    next: function(el) {
        return el.nextElementSibling;
    },
    attr: function(el, attr) {
        return el.getAttribute(attr);
    },
    data: function(el) {
        return el.getAttribute('data');
    },
    append: function(el, parent) {
        parent.append(el);
    },
    prepend: function(el, parent) {
        parent.prepend(el);
    },
    animate: function(el) {

    },
    offset: function(el) {
        box     = el.getBoundingClientRect();
        docElem = document.documentElement;
        return {
            top: box.top + window.pageYOffset - docElem.clientTop,
            left: box.left + window.pageXOffset - docElem.clientLeft
        };
    },
    empty: function(el) {
        el.replaceChildren();
    },
    wrap: function(el, wrapEl, elClass) {
        const wrappingElement = document.createElement(wrapEl);
        wrappingElement.className(elClass);
        el.replaceWith(wrappingElement);
        wrappingElement.appendChild(el);
    },
    ready: function() {
      if (document.readyState !== 'loading') {
        fn();
      } else {
        document.addEventListener('DOMContentLoaded', fn);
      }
    },
    on: function(el, eventName, eventHandler, selector) {
        if (selector) {
            const wrappedHandler = function(e) {
              if (e.target && e.target.matches(selector)) {
                eventHandler(e);
              }
            };
            el.addEventListener(eventName, wrappedHandler);
            return wrappedHandler;
        } else {
            el.addEventListener(eventName, eventHandler);
            return eventHandler;
        }
    },
    slideUp: function(target, duration) {

        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.boxSizing = 'border-box';
        target.style.height = target.offsetHeight + 'px';
        target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;

        window.setTimeout( function() {
          target.style.display = 'none';
          target.style.removeProperty('height');
          target.style.removeProperty('padding-top');
          target.style.removeProperty('padding-bottom');
          target.style.removeProperty('margin-top');
          target.style.removeProperty('margin-bottom');
          target.style.removeProperty('overflow');
          target.style.removeProperty('transition-duration');
          target.style.removeProperty('transition-property');
        }, duration);
    },

    slideDown: function(target, duration) {
        target.style.removeProperty('display');
        let display = window.getComputedStyle(target).display;

        if (display === 'none') {
          display = 'block';
        }

        target.style.display = display;
        let height = target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        target.offsetHeight;
        target.style.boxSizing = 'border-box';
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = duration + 'ms';
        target.style.height = height + 'px';
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        window.setTimeout( function() {
          target.style.removeProperty('height');
          target.style.removeProperty('overflow');
          target.style.removeProperty('transition-duration');
          target.style.removeProperty('transition-property');
        }, duration);
    },

    slideToggle: function(target, duration) {
      if (window.getComputedStyle(target).display === 'none') {
          return window.helpers.slideDown(target, duration);
        } else {
          return window.helpers.slideUp(target, duration);
        }
    },
    scrollTop: function(el, value) {
        if (value === undefined) {
            return el.pageYOffset;
        } else {
            if (el === window || el.nodeType === 9) {
                el.scrollTo(el.pageXOffset, value);
            } else {
                el.pageYOffset = value;
            }
        }
    },
    hide: function(el) {
        el.style.display = 'none';
    },
    fadeIn: function(el, display) {
        el.style.opacity = 0;
        el.style.display = display || "block";
        (function fade() {
            var val = parseFloat(el.style.opacity);
            if (!((val += .1) > 1)) {
                el.style.opacity = val;
                requestAnimationFrame(fade);
            }
        })();
    },
    fadeOut: function(el) {
        el.style.opacity = 1;
        (function fade() {
            if ((el.style.opacity -= .1) < 0) {
                el.style.display = "none";
            } else {
                requestAnimationFrame(fade);
            }
        })();
    },
    scrollToTarget(targetId) {
        
        // Get the target element by its ID
        const targetElement = document.getElementById(targetId);

        if (targetElement) {
            // Calculate the scroll position of the target element with an offset of 150px
            const offset = targetElement.offsetTop - 150;

            // Scroll the page to the target element
            window.scrollTo({
              top: offset,
              behavior: 'smooth' // Add smooth scrolling effect
            });
        }
    }
};